export const formatPrice = (
  priceStart,
  minAbbreviation = '',
  roundPlain = false,
  useThousandsSeparator = false,
  isAround = false
) => {
  let price = Number(priceStart);
  if (isNaN(price)) return '0';

  if (isAround && price >= 1) {
    price = Math.round(price);
  }

  const minLevel = {
    'T': 1e12,
    'B': 1e9,
    'M': 1e6,
    'K': 1e3,
    '': 0,
  }[minAbbreviation.toUpperCase()] || 0;

  let formattedValue;

  if (price >= 1e12 && minLevel <= 1e12) {
    formattedValue = (price / 1e12).toFixed(1) + 'T';
  } else if (price >= 1e9 && minLevel <= 1e9) {
    formattedValue = (price / 1e9).toFixed(1) + 'B';
  } else if (price >= 1e6 && minLevel <= 1e6) {
    formattedValue = (price / 1e6).toFixed(1) + 'M';
  } else if (price >= 1e3 && minLevel <= 1e3) {
    formattedValue = (price / 1e3).toFixed(1) + 'K';
  } else {
    let plain;
    if (isAround && price >= 1) {
      plain = Math.round(price);
    } else if (roundPlain) {
      plain = Math.round(price);
    } else {
      if (price < 0.1) {
        plain = price.toFixed(4);
      } else {
        plain = price.toFixed(2);
      }
    }
    formattedValue = useThousandsSeparator
      ? Number(plain).toLocaleString('en-US')
      : plain.toString();
  }

  return formattedValue;
};

export const formatWithCommas = (number, options = {}) => {
  const num = Number(number);
  if (isNaN(num)) return number;

  return num.toLocaleString('en-US', options);
};

export const formatPriceFull = (priceStart) => {
  const num = Number(priceStart);
  if (isNaN(num)) return priceStart;

  if (num > 0 && num < 0.00001) {
    const decimals = Math.min(10, Math.ceil(Math.abs(Math.log10(num))) + 2);
    return num.toFixed(decimals).replace(/\.?0+$/, '');
  }

  let minimumFractionDigits = 1;
  let maximumFractionDigits = 1;

  if (num < 100) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 2;
  }
  if (num < 10) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 3;
  }
  if (num < 1) {
    minimumFractionDigits = 2;
    maximumFractionDigits = 5;
  }

  let formatted = formatWithCommas(num, {
    minimumFractionDigits,
    maximumFractionDigits,
  });

  formatted = formatted.replace(/(\.\d*?[1-9])0+$/g, '$1');
  formatted = formatted.replace(/\.0+$/g, '');

  return formatted;
};

export const formatVolume = (value, currency = '$') => {
  const num = parseFloat(value);
  if (isNaN(num)) return '0';
  if (num >= 1e9) return (num / 1e9).toFixed(1) + ' млрд ' + currency;
  if (num >= 1e6) return (num / 1e6).toFixed(1) + ' млн ' + currency;
  return num.toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + ' ' + currency;
};

export const formatPriceFullCents = (priceStart) => {
  const num = Number(priceStart);
  if (isNaN(num)) return priceStart;

  let result = num;

  if (num > 0 && num < 0.00001) {
    const decimals = Math.min(10, Math.ceil(Math.abs(Math.log10(num))) + 2);
    result = parseFloat(num.toFixed(decimals));
  } else {
    let minimumFractionDigits = 1;
    let maximumFractionDigits = 1;

    if (num < 100) {
      minimumFractionDigits = 2;
      maximumFractionDigits = 2;
    }
    if (num < 10) {
      minimumFractionDigits = 2;
      maximumFractionDigits = 3;
    }
    if (num < 1) {
      minimumFractionDigits = 2;
      maximumFractionDigits = 5;
    }

    const factor = Math.pow(10, maximumFractionDigits);
    result = Math.round(num * factor) / factor;
  }

  return +(result * 100).toFixed(2);
};